import {AfterContentInit, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {CompanyComponent} from '../../company/company.component';
import {ExgModalService, ExgSelectComponent} from 'exc-controls-v2';
import {ExgTextareaInputComponent} from '../../misc/exg-textarea-input/exg-textarea-input.component';
import {ApplicationService} from '../../services/application.service';
import {ExcSecurityService} from 'exc-security-v2';
import {ExcRestService} from 'exc-rest-v2';
import {ExgApplicationEventEmitter} from '../../misc/classes/ExgApplicationEventEmitter';

@Component({
  selector: 'app-receipt',
  templateUrl: './receipt-details.component.html',
})
export class ReceiptDetailsComponent
  extends ExcTranslation
  implements OnInit, AfterContentInit
{
  /*              Inputs             */
  @ViewChild('VCrcptTyp') VCrcptTyp!: ExgSelectComponent;
  @ViewChild('VCDesc', { read: ExgTextareaInputComponent })
  VCDesc!: ExgTextareaInputComponent;
  @ViewChild('VCNumber', { read: ElementRef }) VCNumber!: ElementRef;
  @ViewChild('VCcompanyForm', { read: CompanyComponent })
  VCcompanyForm!: CompanyComponent;
  /*              Inputs              */
  @Input()
  canChangeEditMode = false;
  @Input()
  set DataReceipt(value: any) {
    if (value.receipt) {
      this.receipt = this.prepareDataForm(value.receipt);
      // this.chDecRef.markForCheck();
    }
    if (value.details) {
      this.Details = this.clone(value.details);
      // this.chDecRef.markForCheck();
    }
  }
  get DataReceipt(): any {
    return this._receipt;
  }
  _taxVisible = true;
  /*              Input-Company              */
  @Input()
  set CompanyData(data: any) {
    this._CompanyData = this.clone(data);
  }
  get CompanyData(): any {
    if (!this.visibilityController.companyLink) {
      return this._CompanyData;
    } else {
      if (this.visibilityController.linkedCompID) {
        return this.checkview.workspace.companyLinkData.find((comp: any) => comp.compID === this.visibilityController.linkedCompID);
      } else {
        return undefined;
      }
    }
  }
  @Input()
  checkview: any;

  /*              Objects             */
  // tslint:disable-next-line:variable-name
  rcpt_enmIdent_ReceiptTypeList = [] as any[];
  rcptObjectList = [] as any[];
  _CompanyData = {};
  _receipt: any;
  _receiptClone: any;
  _receiptEditMode = false;

  expand = false;
  Events = new ExgApplicationEventEmitter();

  details = {
    taskDetails: {} as any,
    caseDetails: {} as any,
    caseLocation: {} as any,
    caseOEs: [] as any[],
    loadDetails: (
      caseDate: any,
      taskDate: any,
      locationData: any,
      oeData: any
    ) => {
      this.details.loadCaseDetails(caseDate);
      this.details.loadTaskDetails(taskDate);
      this.details.loadCaseOEs(oeData);
      this.details.loadCaseLocation(locationData);
    },
    loadCaseDetails: (caseData: any) => {
      this.details.caseDetails = caseData;
    },
    loadTaskDetails: (taskData: any) => {
      this.details.taskDetails = taskData;
    },
    loadCaseLocation: (SO: any) => {
      if (SO) {
        this.details.caseLocation = SO;
      } else {
        this.details.caseLocation = {};
      }
    },
    loadCaseOEs: (OEs: any) => {
      if (OEs) {
        this.details.caseOEs = OEs;
      } else {
        this.details.caseOEs = [];
      }
    },
  };

  set Details(value: any) {
    this.details.loadDetails(
      value.caseDetails,
      value.taskDetails,
      value.caseLocation,
      value.caseOEs
    );
  }

  visibilityController = {
    defaultValue: {
      company: false,
    },
    setDefault: () => {
      if (this.visibilityController.companyForm) {
        this.visibilityController.companyForm =
          this.visibilityController.defaultValue.company;
      }
      if (this.receiptEditMode) {
        this.switchEditMode(this.checkview.securityHandler.canEdit());
      }
    },
    /******/
    companyLink: false,
    linkedCompID: undefined as any,
    companyForm: false,
    companySwitch: (link = false, compID?: any) => {
      const wasSupplement = this.checkview && this.checkview.aiSupplementMode;

      if (this.checkview) {
        this.checkview.aiSupplementMode = false;
        if (wasSupplement) {
          this.checkview.workspace.company = this.checkview.aiSupplementPrevCompany;
          this.checkview.aiSupplementPrevCompany = null;
        }

      }
      this.visibilityController.companyLink = link;
      if (this.visibilityController.companyLink) {
        this.visibilityController.linkedCompID = compID;
      } else {
        this.visibilityController.linkedCompID = undefined;
      }
      const newValue = !this.visibilityController.companyForm;

      if (
        !wasSupplement &&
        this.visibilityController.companyForm &&
        this.VCcompanyForm?.companyChanged()
      ) {
        this.VCcompanyForm.beforeClose();
        this.chDecRef.markForCheck();
      }

      this.Events?.Receipt?.Checkview?.CheckDuplicates?.emit();
      this.visibilityController.companyForm = newValue;
      this.chDecRef.detectChanges();
    },
  };
  /************************/
  constructor(
    public chDecRef: ChangeDetectorRef,
    public enumSvc: EnumerationService,
    public excSecurity: ExcSecurityService,
    public excRestService: ExcRestService,
    private appSvc: ApplicationService,
    private modalSvc: ExgModalService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initialize();
  }

  ngAfterContentInit(): void {
    // // this.chDecRef.markForCheck();
  }

  initialize(changeEditmode?: boolean, cancel?: boolean): void {
    const DATAReceipt = this.receipt;
    this.rcpt_enmIdent_ReceiptTypeList =
      this.enumSvc.getEnumerationList('ReceiptType');

    if (this.receiptEditMode && this.canChangeEditMode && changeEditmode) {
      if (this.visibilityController.companyForm) {
        this.visibilityController.companySwitch();
      } else if (cancel) {
        this.visibilityController.setDefault();
      }
    }

    if (DATAReceipt) {
      this.receipt = this.prepareDataForm(DATAReceipt);
    }

    this.receiptCompanyInit();
  }

  receiptCompanyInit(changeEditmode?: boolean): void {
    const DATAComp = this.CompanyData;

    if (this.visibilityController.companyForm && changeEditmode) {
      this.visibilityController.companyForm = false;
    }

    if (DATAComp) {
      if (this.VCcompanyForm?.companyChanged()) {
        this.checkview.companyRFillObject();
      }
    }

    this.Events?.Receipt?.Checkview?.CheckDuplicates?.emit();
    this.chDecRef.detectChanges();
  }

  /*       */
  get receipt(): any {
    return this._receipt;
  }
  set receipt(obj: any) {
    this._receipt = obj;
    this.receiptClone = this.clone(obj);
  }
  set receiptClone(obj: any) {
    this._receiptClone = obj;
    this.chDecRef.markForCheck();
  }

  get receiptClone(): any {
    if (this.rcptDesc) {
      this._receiptClone.rcptDesc = this.rcptDesc;
    }
    return this._receiptClone;
  }

  switchEditMode(canSwitch?: boolean): void {
    if (canSwitch) {
      this.receiptEditMode = !this.receiptEditMode;

      if (!this.receiptEditMode) {
        this.receiptClone = this.prepareDataForm(this.receipt);
        // this.chDecRef.markForCheck();
      }
    }
    this.chDecRef.detectChanges();
  }
  get receiptEditMode(): boolean {
    return this._receiptEditMode ? this._receiptEditMode : false;
  }
  set receiptEditMode(value: boolean) {
    if (value && this.checkview) {
      this.checkview.checkChanges = true;
    }
    if (this.canChangeEditMode) {
      this._receiptEditMode = value;
    }
  }
  get rcptChanged(): boolean {
    return JSON.stringify(this.receiptClone) !== JSON.stringify(this.receipt);
  }

  set rcptDesc(value: string) {
    this._receiptClone.rcptDesc = value;
  }

  get rcptDesc(): string {
    return !this.VCDesc ? this._receiptClone?.rcptDesc : this.VCDesc.value;
  }

  /* Steuerbereich sichtbarkeit   */
  get taxVisible(): boolean {
    return this._taxVisible;
  }

  set taxVisible(value: boolean) {
    this._taxVisible = value;
  }

  /* Prep 4 ResultView  */
  calcBrutto(sumCorr?: number, rcptClone?: boolean): number {
    const base: number = this.getNetto(sumCorr, rcptClone);

    return this.roundCommercial(this.calcVAT(sumCorr, rcptClone) + base);
  }
  calcVAT(sumCorr?: number, rcptClone?: boolean): number {
    const rcpt = rcptClone ? this.receiptClone : this.receipt;
    const base: number = this.getNetto(sumCorr, rcptClone);

    return this.roundCommercial((base * rcpt?.rcptVATRate) / 100);
  }

  getNetto(sumCorr?: number, rcptClone?: boolean): number {
    const rcpt = rcptClone ? this.receiptClone : this.receipt;
    return Number(rcpt?.rcptNetSum) - (sumCorr ? sumCorr : 0);
  }
  calcDiffBrutto(sumCorr?: number, rcptClone?: boolean): number {
    return this.calcBrutto(0, rcptClone) - this.calcBrutto(sumCorr, rcptClone);
  }
  calcDiffVAT(sumCorr?: number, rcptClone?: boolean): number {
    return this.calcVAT(0, rcptClone) - this.calcVAT(sumCorr, rcptClone);
  }
  calcDiffNetto(sumCorr?: number, rcptClone?: boolean): number {
    return this.getNetto(0, rcptClone) - this.getNetto(sumCorr, rcptClone);
  }

  replaceNull(input: any): string {
    if (!input) {
      return '';
    } else {
      return input;
    }
  }

  clone(cloneObj: any): any {
    return JSON.parse(JSON.stringify(cloneObj));
  }

  calcRcptBrutto(netValue: any, vatValue: any): void {
    const rcpt = this.receiptClone;
    rcpt.rcptNetSum = netValue;
    rcpt.rcptVATRate = vatValue;

    if (rcpt) {
      if (
        rcpt.rcptVATRate &&
        rcpt.rcptNetSum &&
        rcpt.rcptNetSum > 0 &&
        rcpt.rcptVATRate > 0
      ) {
        rcpt.rcptGrossSum = !rcpt.taxVisible
          ? this.calcBrutto(0, true)
          : this.getNetto(0, true);
      } else {
        rcpt.rcptGrossSum = this.getNetto(0, true);
      }
    }
  }

  taxValueChanged(): void {
    const rcpt = this.receiptClone;
    if (rcpt.rcptVATRate !== 0) {
      this.calcRcptBrutto(rcpt.rcptNetSum, 0);
    }
  }

  getOEByID(ID: string): any | undefined {
    return ExcCoreModule.Array?.GetObject(this.details.caseOEs, 'oeID', ID);
  }

  prepareDataForm(DATAReceipt: any): any {
    const rcpt = this.clone({
      rcptID: DATAReceipt.rcptID,
      rcptUPT: DATAReceipt.rcptUPT,
      rcpt_enmIdent_ReceiptType: DATAReceipt.rcpt_enmIdent_ReceiptType
        ? DATAReceipt.rcpt_enmIdent_ReceiptType
        : 100,
      rcpt_enmIdent_ReceiptStatus: DATAReceipt.rcpt_enmIdent_ReceiptStatus,
      rcptDesc: this.replaceNull(DATAReceipt.rcptDesc),
      rcptDate: DATAReceipt.rcptDate,
      rcptNumber: this.replaceNull(DATAReceipt.rcptNumber),
      rcptComp: this.replaceNull(DATAReceipt.rcptComp),

      rcptVATRate: DATAReceipt.rcptVATRate ? Number(DATAReceipt.rcptVATRate) : 0,
      rcptGrossSum: DATAReceipt.rcptGrossSum ? Number(DATAReceipt.rcptGrossSum) : 0,
      rcptNetSum: DATAReceipt.rcptNetSum ? Number(DATAReceipt.rcptNetSum) : 0,

      rcptObject: this.replaceNull(DATAReceipt.rcptObject),
      rcptIdentifiersCompany: this.replaceNull(
        DATAReceipt.rcptIdentifiersCompany
      ),
    });

    this.receiptObjectListInit(rcpt);

    return rcpt;
  }

  roundCommercial(value: number, decimals = 2): number {
    const sign = Math.sign(value);
    // Exponential-Schreibweise statt * 10^n, um Float-Fehler bei x.xx5 zu vermeiden
    const shifted = Number(`${Math.abs(value)}e${decimals}`);
    return sign * Number(`${Math.round(shifted)}e-${decimals}`);
  }

  receiptObjectListInit(receiptObj: any): void {
    this.rcptObjectList = this.getObjectList(receiptObj);
  }

  openObjectEditor(): void {
    this.appSvc.Receipt.ObjectEditor.OpenModal(this.receiptClone).subscribe(
      (rtValue: any) => {
        if (rtValue) {
          this.receiptClone.rcptObject = rtValue.rcptObject;

          this.receiptObjectListInit(this.receiptClone);
        }
      }
    );
  }

  getObjectList(receiptData: any): any[] {
    if (receiptData.rcptObject && receiptData.rcptObject.length > 0) {
      return JSON.parse(receiptData.rcptObject);
    }
    return [];
  }

  chipClose_resetObject(rmvObj: any): void {
    this.rcptObjectList = this.rcptObjectList.filter((listObj: any) => listObj.enmIdent !== rmvObj.enmIdent);
    this.receiptClone.rcptObject = JSON.stringify(this.rcptObjectList);
  }
}
